function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Westlands-Stockist-Finder",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stockist-Finder---Landing-Page---Mobile",
  transform: "translate(-164.000000, -467.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Stockist-search-panel",
  transform: "translate(15.000000, 179.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "OR",
  transform: "translate(149.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  stroke: "#FFFFFF",
  strokeWidth: 2,
  fill: "#046A38",
  cx: 24,
  cy: 24,
  r: 23
}), /*#__PURE__*/React.createElement("text", {
  id: "or",
  fontFamily: "Arial-BoldMT, Arial",
  fontSize: 20,
  fontWeight: "bold",
  "line-spacing": 26,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 14,
  y: 28
}, "or"))))));

function SvgOr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OR") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOr);
export default __webpack_public_path__ + "static/media/or.07bbb5a3.svg";
export { ForwardRef as ReactComponent };